"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.upgrade.message': 'Aggiorna il tuo piano account per accedere a questa funzione.',
    'limits.upgrade.link': 'Aggiorna Ora',
};
